import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { Campaign, Leads, Message, Report, ManageAgent, ManageDisposition, ManageCrmlabel, Did, ManageDidnumber, PinsForm, Grouplist } from './model/campaign.model';
import { Custdisposition, Option } from '../shared/model/model.class';
import { SocketService } from '../shared/service/socket.service';
import { APIURL } from '../app-routing.module';
import { AppService } from '../shared/service/AppService.class';
import { BehaviorSubject } from 'rxjs';
// import { replaceAll } from 'chartist';

/**
 * Campaign module services
 */
@Injectable()
export class CampaignService extends AppService<Campaign>{
  constructor(protected http: HttpClient) {
    super(http);
    this.appmod = "campaign";
  }
  
  getAllCampaign(): Observable<any> {
    let tmp=this.appmod
    this.appmod = "custom/allcampaign";
    let result = super.getService();
    this.appmod=tmp
    return result;
  }

  getLeadGroupData(data){
    let tmp=this.appmod
    this.appmod = "getcampleadgroup";
    let result = super.getService('', JSON.stringify(data));
    this.appmod=tmp
    return result;
  }
  getCampDate(data){
    let tmp=this.appmod
    this.appmod = "getcampdate";
    let result = super.getService('', JSON.stringify(data));
    this.appmod=tmp
    return result;
  }
  public DIDstate_count(data:any){
    let tmp=this.appmod
    this.appmod = "countdidstate";
    let result = super.getService('', data);
    this.appmod=tmp
    return result;
  }
  updateDate(id,data){
    let tmp=this.appmod
    this.appmod = "custom/updatecampdate";
    let result = super.updateService(data,id);
    this.appmod=tmp
    return result;
  }
  public getStateCount(data:any){
    let tmp=this.appmod
    this.appmod = "lead";
    let result = super.getService('leadlist',data);
    this.appmod=tmp
    return result;
  }

  public deletecampaign(id): Observable<any> {
    let tmp=this.appmod
    this.appmod = "custom/delete";
    let result = super.deleteService(id);
    this.appmod=tmp
    return result;
  }

  public checkvalidcamp(id,type): Observable<any> {
    let tmp=this.appmod
    this.appmod = "custom/getvaliddata";
    let result = super.getService(id,type);
    this.appmod=tmp
    return result;
  }

  getIVR():Observable<any>{
    this.appmod = "getivr";
    let result = super.getService();
    this.appmod = "campaign";
    return result;
  }

  getCallDispositions(): Observable<any> {
    this.appmod = "getcalldispositions";
    let result = super.getService();
    this.appmod = "campaign";
    return result;
  }

  getCampaignLeadRecycle(campid: any): Observable<any> {
    let tmp = this.appmod;
    this.appmod = "getcampaignleadrecycle";
    let result = super.getService('', campid);
    this.appmod = tmp;
    return result;
  }
  startcamp(type,id){
    this.appmod = "custom/start";
    let result = super.getService(type,id);
    this.appmod = "campaign";
    return result;
  }
saveAgentGroup(data){
  this.appmod = "custom/saveAgentGroups";
  let result = super.saveService(data);
  this.appmod = "campaign";
  return result;
}
changedid(data): Observable<any>{
  this.appmod = "custom/agentsGroup";
  let result = super.saveService(data);
  this.appmod = "campaign";
  return result;
}

  public getMessage1(type = 'main'): Observable<any> {
    this.appmod = "activevoicecampaign";
    let result = super.getOption(type);
    this.appmod = "campaign";
    return result;
  }
  LeadGroup(){
    this.appmod = "leadgroup";
    let result = super.getOption("main");
    this.appmod = "campaign";
    return result;
  }
  getLiveCallsData(date){
    this.appmod = "livecallsdata";
    let result = super.getService(date);
    this.appmod = "campaign";
    return result;
  }
  getCampaignList(){
    this.appmod = "getcampaignlist";
    let result = super.getOption("main");
    this.appmod = "campaign";
    return result;
  }
  public GetfSettingCampaign(camptype, campid?): Observable<any> {
    this.appmod = "custom/getfullsettingcampaign";
    let result = super.getService(camptype, campid);
    this.appmod = "campaign";
    return result;
  }

  public customFields(): Observable<any> {
    return this.http.get("assets/jsondata/customfields.json");
  }

  public getCampDetail(id: any): Observable<any> {
    let temp = this.appmod;
    this.appmod = "custom/campaigndetail";
    let result = super.getService(id);
    this.appmod = temp;
    return result;
  }

  public getCampaignReport(data:any): Observable<any> {
    let temp = this.appmod;
    this.appmod = "getcampaignreport";
    let result = super.saveService(data);
    this.appmod = temp;
    return result;
  }

  public getreportdata(data:any): Observable<any> {
    let temp = this.appmod;
    this.appmod = "getallreportcamp";
    let result = super.saveService(data);
    this.appmod = temp;
    return result;
  }

  public getgraphreport(data:any): Observable<any> {
    let temp = this.appmod;
    this.appmod = "getgraphreportcamp";
    let result = super.saveService(data);
    this.appmod = temp;
    return result;
  }

  public getacasr(data:any): Observable<any> {
    let temp = this.appmod;
    this.appmod = "getacdasrdata";
    let result = super.saveService(data);
    this.appmod = temp;
    return result;
  }

  public weeklyleadsstats(data:any): Observable<any> {
    let temp = this.appmod;
    this.appmod = "getweeklyleads";
    let result = super.saveService(data);
    this.appmod = temp;
    return result;
  }


  public weeklycallstats(data:any): Observable<any> {
    let temp = this.appmod;
    this.appmod = "getallweeklycall";
    let result = super.saveService(data);
    this.appmod = temp;
    return result;
  }

  public gettimewisecall(data:any): Observable<any> {
    this.appmod = "gettimewisecall";
    let result = super.saveService(data);
    // this.appmod = "agents";
    return result;
  }

  public getCamapignDashboard(data){
  
      this.appmod = "dashboard/campaign";
   
    let result = super.saveService(data);
    return result;
  }
  getAreaGraphCampInbound(data){
    this.appmod = "getareacampinbound";
    let result = super.saveService(data);
    // this.appmod = "agents";
    return result;
  }
  public hourlyleadstats(data:any): Observable<any> {
    this.appmod = "hourlyleadstats";
    let result = super.saveService(data);
    // this.appmod = "agents";
    return result;
  }
  getLiveCallsDataOutbound(date){
    this.appmod = "livecallsdataoutbound";
    let result = super.getService(date);
    this.appmod = "campaign";
    return result;
  }
  public getCamapignDashboardOutbound(data){
  
    this.appmod = "dashboard/campaignoutbound";
 
  let result = super.getService(data);
  return result;
}
public hourlyleadstatsoutbound(data:any): Observable<any> {
  this.appmod = "hourlyleadstatsoutbound";
  let result = super.saveService(data);
  // this.appmod = "agents";
  return result;
}

ASRandASDProgressOutbound(data){
  this.appmod = "ASRandASDProgressOutbound";
  let result = super.saveService(data);
  // this.appmod = "agents";
  return result;
}
public camphourlyCallStatsOutBound(data:any): Observable<any> {
  this.appmod = "camphourlyCallStatsoutbound";
  let result = super.saveService(data);
  // this.appmod = "agents";
  return result;
}
  public ASRandASDProgress(data:any): Observable<any> {
    this.appmod = "ASRandASDProgress";
    let result = super.saveService(data);
    // this.appmod = "agents";
    return result;
  }
  getRadialGraph(data){
    this.appmod = "getradialoutbound";
    let result = super.saveService(data);
    // this.appmod = "agents";
    return result;
  }
  getLine3Graph(data){
    this.appmod = "getline3outbound";
    let result = super.saveService(data);
    // this.appmod = "agents";
    return result;
  }
  getPieCampInboundGraph(data){
    this.appmod = "getpiecampInbound";
    let result = super.saveService(data);
    // this.appmod = "agents";
    return result;
  }
  getLine3CampInboundGraph(data){
    this.appmod = "getline3campinbound";
    let result = super.saveService(data);
    // this.appmod = "agents";
    return result;
  }
  public camphourlyCallStats(data:any): Observable<any> {
    this.appmod = "camphourlyCallStats";
    let result = super.saveService(data);
    // this.appmod = "agents";
    return result;
  }
public getRadialCampInboundgraph(data:any){
  this.appmod = "radialcampinboundgraph";
  let result = super.saveService(data);
  // this.appmod = "agents";
  return result;
}
  public getAgentList(id: any): Observable<any> {
    return this.http.get('/assets/jsondata/agentlist_' + id + '.json');
  }

  public getCampaignDetail(id: any): Observable<any> {
    return this.http.get('/assets/jsondata/campaignagentdetail_5f84296d14f2346d53a86218.json');
  }

  public didsmsdata(id: any): Observable<any> {
    return this.http.get('/assets/jsondata/didsmsdata_' + id + '.json');
  }

  public didmisscalldata(id: any): Observable<any> {
    return this.http.get('/assets/jsondata/didmisscall_' + id + '.json');
  }

  public didNotifyData(id: any): Observable<any> {
    return this.http.get('/assets/jsondata/didnotifydata_' + id + '.json');
  }

  public getCampignhourlattemptDetail(id?: any): Observable<any> {
    return this.http.get('/assets/jsondata/campaignhourlydistribution_' + id + '.json');
  }

  public getCampignDailylattemptDetail(id?: any): Observable<any> {
    return this.http.get('/assets/jsondata/campaigndailyattemptdistribution_' + id + '.json');
  }

  public getCampignhourtransfer(id?: any): Observable<any> {
    return this.http.get('/assets/jsondata/campaignhourlytransfer_' + id + '.json');
  }

  public getCampignDailytransfer(id?: any): Observable<any> {
    return this.http.get('/assets/jsondata/campaigndailytransfer_' + id + '.json');
  }

  public getReportCdr(filter): Observable<any> {
    this.appmod = "getreportdynamic"
    let result = super.getService('current', filter);
    this.appmod = "getcdr";
    return result;
  }

  public getCallReport(id?: any): Observable<any> {
    return this.http.get('/assets/jsondata/campaignhourlydetails_' + id + '.json');
  }

  public getCampaignDailyReport(id?: any): Observable<any> {
    return this.http.get('/assets/campaigndetails.json');
  }

  public getCampaignAgentDailyReport(id?: any): Observable<any> {
    return this.http.get('/assets/jsondata/campaignagentdetail_' + id + '.json');
  }

  public getCampignAgentDistribution(id?: any): Observable<any> {
    return this.http.get('/assets/jsondata/campaignagentdistribution_' + id + '.json');
  }

  public getLeads(campid?: number): Observable<any> {
    return super.getService('uploads', JSON.stringify({ "upload_type": "1" }));
  }

  public getLeadsGroup(campid?: number): Observable<any> {
    return super.getService('uploadsleadgroup', JSON.stringify({ "listgroup_type": campid }));
  }

  public getLiveParymsg(): Observable<Option[]> {
    return super.getOption("uploads");
  }

  public getAudio(where): Observable<any> {
    return super.getService("getauodio", undefined, where);
  }

  public LiveBoard() {
    return this.getReport("voiceliveboard");
  }

  public getVoicePartyMsg(): Observable<Option[]> {
    return super.getOption("uploads");
  }

  public getProvider(): Observable<Option[]> {
    return super.getOption("provider");
  }

  public ActiveCampaign() {
    return super.getReport("activevoicecampaign");
  }

  public getMessage(): Observable<Option[]> {
    return super.getOption("message");
  }

  public getState(): Observable<Option[]> {
    return super.getOption("state");
  }

  public getCampaign(): Observable<any[]> {
    return super.getService("copycampaigno", JSON.stringify({ "cam_type": "1" }));
  }

  public getCampKeySetting(campid): Observable<any> {
    this.appmod = "campaign";
    return super.getService('getcampkeysetting', JSON.stringify({ id_campaign: campid }));
  }

  public getDidOpt(): Observable<Option[]> {
    return super.getOption("did");
  }

  public getDidGroup(): Observable<any> {
    this.appmod = "getdidgroup";
    let result = super.getService();
    this.appmod = "questdidnumber";
    return result;
  }

  public getGroupOpt(data): Observable<any> {
    this.appmod = "getgroupopt";
    let result = super.getService(undefined, undefined, data);
    this.appmod = "questdidnumber";
    return result;
  }

  public getAgentOpt() {
    this.appmod = "predictive/agentopt";
    let result = super.getService();
    this.appmod = "campaign";
    return result;
  }

  public leadList(groupID): Observable<any> {
    this.appmod = "leadlist";
    let result = super.getService(groupID);
    this.appmod = "leadslist"
    return result;
  }

  public getTimezone(): Observable<any> {
    return super.getService("glbtimezonesetting");
  }

  public getMappedDid(campid): Observable<any> {
    this.appmod = 'didmapping';
    let result = super.getService('didmapping', JSON.stringify({ campaign_id: campid }));
    this.appmod = "campaign";
    return result;
  }

  public getSingleCampaign(campid): Observable<any> {
    this.appmod = "singlecampaign";
    let result = super.getService('singlecampaign', campid);
    this.appmod = "campaign";
    return result;
  }

public getInfo(title): Observable<any> {
    this.appmod = "information";
    let result = super.getService('title', title);
    this.appmod = "campaign";
    return result;    
  }  public DispoReports(campid:number): Observable<any> {
    this.appmod = "getdispositionrpts";
    let result = super.getService('getdispositionrpts', campid);
    this.appmod = "campaign";
    return result;
  }

  public KeyPressRPT(campid:number): Observable<any> {
    this.appmod = "getkeypressrpt";
    let result = super.getService('getkeypressrpt', campid);
    this.appmod = "campaign";
    return result;
  }

  public createCampaign(data: any, arg): Observable<any> {
    console.log("getting data here to varify",arg);
    this.appmod = "custom/campaign";
    let result = super.saveService(data, arg);
    this.appmod = "campaign";
    return result;
  }

  public updateCampaign(data: any, key:any, disStatus?:any, argument?:any): Observable<any> {
    console.log("check data of argument",data);
    
    this.appmod = 'custom/updatecampsettings/';
    let result = super.updateService(data, key, disStatus, argument);
    this.appmod = 'campaign';
    return result;
  }

  public updateCampaignrecording(data: any, id): Observable<any> {
    this.appmod = 'custom/updatecampaignrecording/';
    let result = super.updateService(data, id);
    this.appmod = 'campaign';
    return result;
  }


  public updateCampaignTimeing(data: any, key): Observable<any> {
    this.appmod = 'custom/updatecamptiming';
    let result = super.updateService(data, key);
    this.appmod = 'campaign';
    return result;
  }

  public downloadLeads(data: any): Observable<any> {
    this.appmod = 'custom/downloadleads';
    let result = super.getDownload(data, 'downloadleads');
    this.appmod = 'campaign';
    return result;
  }
  public downloadCdr(data: any): Observable<any> {
    this.appmod = 'custom/downloadcdr';
    let result = super.getDownload(data, 'downloadcdr');
    this.appmod = 'campaign';
    return result;
  }

  public downloadDNC(data: any): Observable<any> {
    this.appmod = 'custom/downloaddnc';
    let result = super.getDownload(data, 'downloaddnc');
    this.appmod = 'campaign';
    return result;
  }

  public updateAudioMessage(data: any, key: number): Observable<any> {
    this.appmod = "updateaudiomessage";
    let result = super.updateService(data, key);
    this.appmod = "campaign";
    return result;
  }

  public manageDidnumber(data: any): Observable<any> {
    return super.saveService(data);
  }

  public getChannel(): Observable<any> {
    this.appmod = "getchannel";
    let result = super.getService('getchannel');
    this.appmod = "campaign";
    return result;
  }

  public getUploadedFiles(leadgrpid): Observable<any> {
    this.appmod = "getuploadedfile";
    let result = super.getService(leadgrpid);
    return result;
  }

  public CountStateDID(groupID): Observable<any> {
    this.appmod = "countdidstate";
    let result = super.getService('', groupID);
    this.appmod = "campaign";
    return result;
  }

  public CountStateSmsTemeplete(groupID): Observable<any> {
    console.log("hello ajay::::::", groupID)
    this.appmod = "countdidstateSms";
    let result = super.getService(groupID);
    this.appmod = "campaign";
    return result;
  }

  public CountStateVoiceTemeplete(groupID): Observable<any> {
    console.log("hello ajay::::::", groupID)
    this.appmod = "countdidstateVoice";
    let result = super.getService(groupID);
    this.appmod = "campaign";
    return result;
  }

  public GetCampaigns(): Observable<any> {
    this.appmod = "get_campaigns";
    let result = super.getService();
    this.appmod = "campaign";
    return result;
  }
  public GetCampaignsList(): Observable<any> {
    this.appmod = "getcampaigns";
    let result = super.getService();
    this.appmod = "campaign";
    return result;
  }
  public CreateCloserCampaign(data: any, arg): Observable<any> {
    this.appmod = "create_closer_campaign";
    let result = super.saveService(data, JSON.stringify(arg));
    this.appmod = "campaign";
    return result;
  }

  public UpdateCloserCampaign(data: any, arg): Observable<any> {
    this.appmod = "update_closer_campaign";
    let result = super.saveService(data, JSON.stringify(arg));
    this.appmod = "campaign";
    return result;
  }


  /**
   * Reports services
   */
  public ReportCampaignCDR(data: any = {}): Observable<any> {
    this.appmod = "get_report_campaign_cdr";
    let result = super.getService(data);
    this.appmod = "campaign";
    return result;
  }

  public ReportCampaignCalls(data: any = {}): Observable<any> {
    this.appmod = "get_report_campaign_calls";
    let result = super.getService(data);
    this.appmod = "campaign";
    return result;
  }

  public ReportCampaignCallReleasedDisposition(data: any = {}): Observable<any> {
    this.appmod = "get_report_campaign_callreleasedispo";
    let result = super.getService(data);
    this.appmod = "campaign";
    return result;
  }


  /**
   * Custom services
   */
  getCRMLabels() {
    let temp = this.appmod;
    this.appmod = 'get_crm_labels';
    let result = this.getService();
    this.appmod = temp;
    return result;
  }

  public updateCRMLabel(data: any): Observable<any> {
    this.appmod = "update_crm_label";
    let result = super.saveService(data);
    this.appmod = "campaign";
    return result;
  }

  GetAudioMSGs() {
    let temp = this.appmod;
    this.appmod = 'get_audio_msgs';
    let result = this.getService();
    this.appmod = temp;
    return result;
  }
  getAgents(id:any){
    let temp = this.appmod;
    this.appmod = 'getAgents';
    let result = this.getService(id);
    this.appmod = temp;
    return result;
  }
  addnew_Agent(data:any,type:any){
    let temp = this.appmod;
    this.appmod = 'agents';
    let result = this.saveService(data,type);
    this.appmod = temp;
    return result;
  }

}


/**
 * Lead module services
 */
@Injectable()
export class LeadsServicecamp extends AppService<Leads>{
  constructor(protected http: HttpClient) {
    super(http);
    this.appmod = "resetleadserrorcode";
  }
  public resetIsdnErrorCode(data: any): Observable<any> {

    return super.saveService(data);
  }
  public getLeads() {
    return super.getService("uploads", undefined, undefined);
  }
  public getleadlist(where): Observable<any> {

    return super.getService("leadfile", undefined, where);
  }

  public Deleteloads(id) {
    this.appmod = 'custom/deletecontact';
    let result = super.deleteService(id);
    this.appmod = 'resetleadserrorcode';
    return result;
  }
  public releaseleadlist(key): Observable<any> {
    this.appmod = 'custom/releaseleadlist/';
    let result = super.updateService("", key);
    this.appmod = 'resetleadserrorcode';
    return result;
  }
  public addProcessedLeadsToCampaign(data: any, key: number, type) {
    return super.updateService(data, key, type);
  }
}


/**
 * Agent module services
 */
@Injectable()
export class ManageAgentService extends AppService<ManageAgent>{
  constructor(protected http: HttpClient) {
    super(http);
    this.appmod = "manageagent";
  }

  public manageAgent(data: any): Observable<any> {
    return super.saveService(data);
  }

  public getAgentRelation(where: any): Observable<any> {
    this.appmod = 'getagentlistcamp';
    let result = super.getService('agentrelation', undefined, where);
    this.appmod = 'manageagent';
    return result;
  }
}


/**
 * DID module services
 */
@Injectable()
export class ManageDidNumberService extends AppService<ManageDidnumber>{
  constructor(protected http: HttpClient) {
    super(http);
    this.appmod = "managedidnumber";
  }

  public manageDidnumber(data: any): Observable<any> {
    return super.saveService(data);
  }

  // public getNumber(data: any): Observable<any> {
  //   this.appmod = "questdidnumber";
  //   let result = super.getCiService('getnumber', 'code', data);
  //   this.appmod = 'managedidnumber';
  //   return result;
  // }

  public getDidRate(): Observable<any> {
    this.appmod = "getdidrate";
    let result = super.getService();
    this.appmod = "managedidnumber";
    return result;
  }

  public getBalance(): Observable<any> {
    this.appmod = "userbalance";
    let resBal = super.getService();
    this.appmod = "managedidnumber";
    return resBal;
  }

  // public BuyDidnumber(data: any): Observable<any> {
  //   this.appmod = 'questdidnumber';
  //   let result = super.saveCiService("buydids", data);
  //   this.appmod = 'managedidnumber';
  //   return result;
  // }

}


/**
 * Pinverification module services
 */
@Injectable()
export class PinVarificationService extends AppService<PinsForm>{
  constructor(protected http: HttpClient) {
    super(http);
    this.appmod = "pinvarification";
  }

  public randomnumber(data: any): Observable<any> {
    this.appmod = 'pinvarification';
    let result = super.saveService(data);
    this.appmod = 'campaign';
    return result;
  }



}


/**
 * Custom Disposition module services
 */
@Injectable()
export class CustomDipositionService extends AppService<ManageDisposition>{
  constructor(protected http: HttpClient) {
    super(http);
    this.appmod = "customedisposition";
  }
  public manageDisposition(data: any): Observable<any> {

    return super.saveService(data);
  }
}


/**
 * Custom Label module services
 */
@Injectable()
export class CustomLabelsService extends AppService<ManageCrmlabel>{
  constructor(protected http: HttpClient) {
    super(http);
    this.appmod = "customelabel";
  }
  public manageDLabel(data: any): Observable<any> {

    return super.saveService(data);
  }
}


/**
 * Manage Service module services
 */
@Injectable()
export class MessageService extends AppService<Message>{
  constructor(protected http: HttpClient) {
    super(http);
    this.appmod = "message";
  }
}


/**
 * Reports module services
 */
@Injectable()
export class ReportService extends AppService<Report>{
  constructor(protected http: HttpClient) {
    super(http);
    this.appmod = "uploads";
  }
}


/**
 * IOSocket module services
 */
@Injectable()
export class IOSocket extends SocketService<any>{

  getCurrentoOn(): Observable<any> {
    return this.RecieveEvents("message");
  }

  openSocket(events: string, data: any): void {
    console.log("Sockets Request initiated");
    this.SendEvents(events, data);
  }
}


/**
 * Lead Group module services
 */
@Injectable()
export class leaduploadService extends AppService<Leads>{
  constructor(protected http: HttpClient) {
    super(http);
    this.appmod = "uploads";
  }

  public getCampaign(): Observable<Option[]> {
    return super.getOption("campaign");
  }

  public getMvCampaign(): Observable<any> {
    return super.getService("movecampaign");
  }


  public processedFileList() {
    return this.http.get<any>(APIURL + 'fileprocessstatus', { headers: { "Content-Type": "application/json" }, params: { type: "main" } });
  }

  public saveHeaderMapping(data: any) {
    return this.http.post<any>(APIURL + 'saveheadermapping', { "data": data }, { headers: { "Content-Type": "application/json" }, params: { type: "main" } });
  }


}


/**
 * DID module services
 */
@Injectable()
export class DidService extends AppService<Did>{
  private didurl: string;
  private response: HttpHeaders;
  constructor(protected http: HttpClient) {
    super(http);
    this.appmod = "did";
    this.didurl = "http://gventure/ci_api/";
  }

  public getAreacode(state: string): Observable<any> {
    this.appmod = 'areacode';
    let result = super.getService("areacode", undefined, state);
    this.appmod = 'questdidnumber';
    return result;
  }

  public getDidNumber(code: string, state: string) {
    return this.http.get(this.didurl + "getdids", { headers: { "Content-Type": "application/json" }, params: { type: "main", state: state, code: code } });
  }

  public buyDidNumber(Didnumber: number, type: number) {
    return;
  }

  public getDidGrpData(): Observable<any> {
    this.appmod = "getdidlistcamp";
    let result = super.getService();
    this.appmod = "questdidnumber";
    return result;
  }

  public DeleteNumber(Didnumber: number) {
    return;
  }

  public getCallerIdSet() {
    return;
  }

  public saveCallerIdSet(data: any) {
    return;
  }


  public getOwnDid(): Observable<any> {
    return super.getService();
  }
  public getDidid(id_group): Observable<any> {
    this.appmod = 'getdidnumbers';
    let result = super.detailService(id_group);
    this.appmod = 'questdidnumber';
    return result;
  }

  public getGroupNum(id_group): Observable<any> {
    this.appmod = 'getgroupnums';
    let result = super.detailService(id_group);
    this.appmod = 'questdidnumber';
    return result;
  }

  public customDid(data: any): Observable<any> {
    let tmp = this.appmod;
    this.appmod = "savecustomedid";
    let result = this.saveService(data);
    this.appmod = tmp;
    return result;
  }


  public getDidNumberAlldid(id_group): Observable<any> {
    this.appmod = 'getDidNumberAlldid';
    let result = super.detailService(id_group);
    this.appmod = 'questdidnumber';
    return result;
  }

  public insertmapdid(data): Observable<any> {
    this.appmod = "savedidmap";
    let result = super.saveService(data);
    return result;
  }
  //save did number 

  public saveDidNumber(data): Observable<any> {
    this.appmod = "savedidnumbers";
    let result = super.saveService(data);
    return result;
  }


  public getDidDetails(where: any): Observable<any> {
    this.appmod = 'didlist';
    let result = super.detailService(where);
    this.appmod = 'questdidnumber';
    return result;
  }

  public getDidGroup(): Observable<any> {
    this.appmod = "getdidgroup";
    let result = super.getService();
    this.appmod = "questdidnumber";
    return result;
  }

  public getDidGroups(): Observable<any> {
    this.appmod = "getdidgroups";
    let result = super.getService();
    this.appmod = "questdidnumber";
    return result;
  }
  public saveDidGroup(data): Observable<any> {
    this.appmod = "getdidgroup";
    let result = super.saveService(data);
    this.appmod = "questdidnumber";
    return result;
  }

  public saveDidGroups(data): Observable<any> {
    this.appmod = "dids";
    let result = super.saveService(data);
    this.appmod = "questdidnumber";
    return result;
  }

  public deleteDidGroup(data): Observable<any> {
    this.appmod = "getdidgroup";
    let result = super.deleteService(data);
    this.appmod = "getdidgroups";
    return result;
  }

  public deletemapdid(data): Observable<any> {
    this.appmod = "deletemapdid";
    let result = super.deleteService(data);
    this.appmod = "getdidgroups";
    return result;
  }


  public DeleteUploadedDid(data): Observable<any> {
    this.appmod = "deleteuploadeddid";
    let result = super.deleteService(data);
    this.appmod = "questdidnumber";
    return result;
  }

  public getDidRate(): Observable<any> {
    this.appmod = "getdidrate";
    let result = super.getService();
    this.appmod = "questdidnumber";
    return result;
  }
  //unassigned did's

  public getGroupOpt() {
    this.appmod = "getgroupopt";
    let result = super.getService();
    this.appmod = "questdidnumber";
    return result;
  }



  public unassigneddid(): Observable<any> {
    this.appmod = 'unassigneddid';
    let result = super.getService();
    this.appmod = 'questdidnumber';
    return result;
  }

  //  public getAreacode(state:string):Observable<any>{
  //   this.appmod='areacode';
  //   let result = super.getService("areacode",undefined, state);
  //   this.appmod='questdidnumber';
  //   return result;
  // }

  // public searchDIDNumber(data): Observable<any> {
  //   this.appmod = 'flowroute';
  //   let result = super.saveCiService("getavailablenumbers", data);
  //   this.appmod = 'questdidnumber';
  //   return result;
  // }

  public search(data: any): Observable<any> {
    let temp = this.appmod;
    this.appmod = "custom/searchdid";
    let result = super.saveService(data);

    this.appmod = temp;
    return result;
  }
  public searchtelnyx(data: any): Observable<any> {
    let temp = this.appmod;
    this.appmod = "custom/searchtelnyx";
    let result = super.saveService(data);

    this.appmod = temp;
    return result;
  }
  public buycallerid(data: any): Observable<any> {
    let tmp = this.appmod;
    this.appmod = "custom/buycallerid";
    let result = this.saveService(data);
    this.appmod = tmp;
    return result;
  }
  public buytelnyxid(data: any): Observable<any> {
    let tmp = this.appmod;
    this.appmod = "custom/buytelnyxid";
    let result = this.saveService(data);
    this.appmod = tmp;
    return result;
  }
  public sendsmstelnyx(data: any): Observable<any> {
    let tmp = this.appmod;
    this.appmod = "custom/sendsmstelnyx";
    let result = this.saveService(data);
    this.appmod = tmp;
    return result;
  }
  public sendsmsthinq(data: any): Observable<any> {
    let tmp = this.appmod;
    this.appmod = "custom/sendsmsthinq";
    let result = this.saveService(data);
    this.appmod = tmp;
    return result;
  }

  // public getNumbers(data): Observable<any> {
  //   this.appmod = 'flowroute';
  //   let result = super.saveCiService("buynumber", data);
  //   this.appmod = 'questdidnumber';
  //   return result;
  // }
  // public getpurchasedNumbers(data): Observable<any> {
  //   this.appmod = 'flowroute';
  //   let result = super.saveCiService("getnumbers", data);
  //   this.appmod = 'questdidnumber';
  //   return result;
  // }
  public randomnumber(data: any): Observable<any> {
    this.appmod = "pinvarification";
    let result = super.saveService(data);
    this.appmod = "questdidnumber";
    return result;
  }
  public getDidGroupList(): Observable<any> {
    this.appmod = "getdidList";
    let result = super.getService();
    return result;
  }
}


/**
 * GroupList module services
 */
@Injectable({
  providedIn: 'root'
})
export class GrouplistService extends AppService<Grouplist>{
  public messageSource = new BehaviorSubject<any>('');
  public currentMessage = this.messageSource.asObservable();

  changeMessage(message: any) {
    this.messageSource.next(message);
  }

  constructor(protected http: HttpClient) {
    super(http);
    this.appmod = "leadslist";
  }

  public leadGroupList(data): Observable<any> {
    this.appmod = "leadsgrouplistcamptype";
    let result = super.getService(undefined, undefined, data);
    this.appmod = "leadslist"
    return result;
  }

  public saveGroup(data): Observable<any> {
    this.appmod = "saveleadgroup";
    let result = super.saveService(data);
    this.appmod = "leadslist";
    return result;
  }

  public updateGroup(data, key): Observable<any> {
    this.appmod = "updateleadgroup";
    let result = super.updateService(data, key);
    this.appmod = "leadslist";
    return result;
  }

  public deleteGroup(key): Observable<any> {
    this.appmod = "deleteleadgroup";
    let result = super.deleteService(key);
    this.appmod = "leadslist";
    return result;
  }

  public getleadfile(): Observable<any> {
    this.appmod = "getleadfile";
    let result = super.getService();
    this.appmod = "leadslist";
    return result;
  }



  public processedFileList() {
    return this.http.get<any>(APIURL + 'campaignleads', { headers: { "Content-Type": "application/json" }, params: { type: "main" } });
  }

  public getleadlist(uploadType): Observable<any[]> {
    return super.getService(uploadType);
  }

  public getGroupType(leadGroup): Observable<any> {
    this.appmod = "getgrouptype";
    let result = super.getService(leadGroup);
    this.appmod = 'leadslist';
    return result;
  }


  public getlist(): Observable<any> {
    this.appmod = "fileprocessstatus";
    let result = super.getOption("main");
    this.appmod = 'leadslist';
    return result;
  }

  public downloadLeads(data: any): Observable<any> {
    let tmp = this.appmod;
    this.appmod = 'custom/downloadleads';
    let result = super.getDownload(data, 'downloadleads');
    this.appmod = tmp;
    return result;
  }

  public getLeadsdata(key): Observable<any> {
    this.appmod = "getleadsdata";
    let result = super.getService("getleadsdata", undefined, key);
    // this.appmod="stripe";
    this.appmod = 'leadslist';
    return result;
  }

  public downloadContList(data: any): Observable<any> {
    this.appmod = 'custom/downloadcontactlist';
    let result = super.getDownload(data, 'downloadcontactlist');
    // this.appmod='dnclist';
    return result;
  }

  public updateLeadStatus(data: any, key): Observable<any> {
    this.appmod = 'custom/updateLeadstatus/';
    let result = super.updateService(data, key);
    this.appmod = 'leadslist';
    return result;
  }

  public getLeadFilter(data: any): Observable<any> {
    this.appmod = 'custom/getLeadFilter/';
    let result = super.getService(data);
    this.appmod = 'leadslist';
    return result;
  }

  public saveHeaderMapping(data: any) {
    return this.http.post<any>(APIURL + 'saveheadermapping', { "data": data }, { headers: { "Content-Type": "application/json" }, params: { type: "main" } });
  }

  public DeleteContact(key): Observable<any> {
    this.appmod = 'custom/deletecontact';
    let result = super.deleteService(key);
    this.appmod = 'leadslist';
    return result;
  }

}


/**
 * Voice Record module services
 */
@Injectable()
export class RecordVoiceService extends AppService<any>{

  constructor(protected http: HttpClient) {
    super(http);
    this.appmod = "recordvoice";
  }

  public sendNumberToDial(number): Observable<any> {
    this.appmod = "sendnumbertodial";
    let result = super.saveService(number);
    this.appmod = "recordvoice";
    return result;
  }

  public getDialingStatus(number): Observable<any> {
    this.appmod = "getdialingstatus";
    let result = super.getService(number);
    this.appmod = "recordvoice";
    return result;
  }

  public getRecordedFile(): Observable<any> {
    this.appmod = "getrecordedfile";
    let result = super.getService();
    this.appmod = "recordvoice";
    return result;
  }

  public deleteNumber(number): Observable<any> {
    this.appmod = "deleterecordnumber";
    let result = super.deleteService(number);
    this.appmod = "recordvoice";
    return result;
  }

  public customFields(): Observable<any> {
    this.appmod = 'customfields';
    let result = super.getService("customfields");
    this.appmod = 'recordvoice';
    return result;
  }

  public listen(data): Observable<any> {
    this.appmod = "listenvoice";
    let result = super.saveService(data);
    this.appmod = "recordvoice";
    return result;
  }

  //  public getVoiceList(lang?:string):Observable<any>{
  //   this.appmod='getvoice';
  //   let result = super.getService("voicelist",lang);
  //   this.appmod='recordvoice';
  //   return result;

  // }

  public getgtts(text): Observable<any> {
    this.appmod = 'savettsmessagefromcampaign';
    // this.appmod='converttts';
    let result = super.saveService(text);
    this.appmod = 'recordvoice';
    return result;
  }







}


/**
 * Custom Dispositions module services
 */
@Injectable()
export class CustdispositionService extends AppService<Custdisposition>{
  constructor(protected http: HttpClient) {
    super(http);
    this.appmod = "customdisposition";
  }

  getDispocamp(data:any){    
    let temp = this.appmod;
    this.appmod = 'custom/campaigndispo';
    let result = this.getService(data);
    this.appmod = temp;
    return result;
  }
  public savecustomdisposition(data: any): Observable<any> {
    let temp = this.appmod;
    this.appmod = 'custom/savecustomdispo';
    let result = this.saveService(data);
    this.appmod = temp;
    return result;
  }
  public changeStatus(data: any): Observable<any> {
    console.log(data,"in service");
    
    let temp = this.appmod;
    this.appmod = 'custom/ChangeStatus';
    let result = this.updateService(data,1);
    this.appmod = temp;
    return result;
  }

  public deleteDis(Id: any): Observable<any> {
    let temp = this.appmod;
    this.appmod = 'custom/deletecustomdispo';
    let result = super.deleteService(Id, "main");
    this.appmod = temp;
    return result;
  }
  getDispoGroup(){
    let temp = this.appmod;
    this.appmod = 'dispogroup';
    let result = super.getService();
    this.appmod = temp;
    return result;
  }

  public getWorkflow(type: string, filter: any): Observable<any> {
    return this.getService(type, filter);
  }

  public RefreshCDisposition(): Observable<any> {
    let temp = this.appmod;
    this.appmod = 'custom/refreshcdisposition';
    let result = this.getService();
    this.appmod = temp;
    return result;
  }

  public UpdateDispoKeys(data: any): Observable<any> {
    let temp = this.appmod;
    this.appmod = 'custom/dispokeysetting';
    let result = this.saveService(data);
    this.appmod = temp;
    return result;

  }

}
